import { ReportContext } from '@/Contexts/ReportContext';
import { CompanyResourceResourceTypeEnum, GetSchedulesDocument } from '@/graphql/generated/graphql';
import { objectLength } from '@/utils/helperFunctions';
import { useQuery } from '@apollo/client/react';
import {
  Box,
  TableContainer,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import dayjs from 'dayjs';
import { useContext } from 'react';
import { map } from 'lodash';
import CurrentUserContext from '@/Contexts/CurrentUser';

const SubcontractorRegister = () => {
  const { dateTimePreference } = useContext(CurrentUserContext);
  const { selectedReport, selectedProject } = useContext(ReportContext);
  const { data } = useQuery(GetSchedulesDocument, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    skip: !selectedReport,
    variables: {
      date: selectedReport?.reportDate as string,
      projectId: selectedProject?.id as string,
      resourceType: CompanyResourceResourceTypeEnum.SubContractor,
    },
  });

  return (
    <TableContainer component={Paper} elevation={1}>
      <Box sx={{ p: 2, bgcolor: '#e3f2fd' }}>
        <Typography variant="h6" sx={{ color: '#0d47a1', fontWeight: 600 }}>
          Subcontractor Register
        </Typography>
      </Box>
      {objectLength(data?.getSchedules) === 0 ? (
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">No schedules recorded for the date.</Typography>
        </Box>
      ) : (
        <Table size="small">
          <TableHead sx={{ bgcolor: '#f5f5f5' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Check In</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Check Out</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Qty</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Location</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {map(data?.getSchedules, (row, index) => (
              <TableRow key={index} hover>
                <TableCell sx={{ fontWeight: 500 }}>{row?.companyResource?.name}</TableCell>
                <TableCell>{dayjs(row?.startTime).format(dateTimePreference.time)}</TableCell>
                <TableCell>{dayjs(row?.endTime).format(dateTimePreference.time)}</TableCell>
                <TableCell>{row.quantity}</TableCell>
                <TableCell>{row?.address.title}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};

export default SubcontractorRegister;
